// Reveals the rest of a list: sets data-expanded on the target, then removes the button.
class SShowMore extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('button');
    const target = document.getElementById(this.dataset.target || '');
    if (!button || !target) return;
    this.hidden = false;
    button.addEventListener('click', () => {
      target.toggleAttribute('data-expanded', true);
      this.remove();
    }, { once: true });
  }
}

if (!customElements.get('s-show-more')) customElements.define('s-show-more', SShowMore);
